// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__KtX61","inputWrap":"styles_inputWrap__1jljq","input":"styles_input__3WcIq"};